import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primeicons/primeicons.css";

import "./styles/_global.scss";
import store from "store/store";
import router from "utils/CreateBrowserRouter";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <RouterProvider router={router} />
  </Provider>
);
